import PropTypes from 'prop-types'
import React, { useState, useCallback, useMemo } from 'react'
import { Card, CardBody, CardHeader, CardFooter } from 'reactstrap'
import LoaderButton from 'components/molecules/loader-button'
import { useDropzone } from 'react-dropzone'

const propTypes = {
  label        : PropTypes.string,
  onFileUpload : PropTypes.func,
  isUploading  : PropTypes.bool
}

/**
 * @param {string} label - title for this csv card component
 * @param {func} onFileUpload - a function to handle upload csv
 * @param {bool} isUploading - a boolean to disable upload button
 */

const CsvUploadCard = ({
  label,
  onFileUpload,
  isUploading
}) => {
  const [ file, setFile ]         = useState(new Blob)
  const [ errorMsg, setErrorMsg ] = useState('')
  /**
  * Upload Form Styling Begins
  */
  const style = useMemo(() => ({
    flex            : 1,
    display         : 'flex',
    flexDirection   : 'column',
    alignItems      : 'center',
    margin          : '20px',
    padding         : '20px',
    borderWidth     : 2,
    borderRadius    : 2,
    borderColor     : '#eeeeee',
    borderStyle     : 'dashed',
    backgroundColor : '#fafafa',
    color           : '#bdbdbd',
    outline         : 'none',
    transition      : 'border .24s ease-in-out'
  }), [])

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0])
      setErrorMsg('')
    } else {
      setFile(new Blob)
      setErrorMsg('Please upload file with .csv, .xls, or .xlsx format.')
    }
  }, [])

  const {
    getRootProps,
    getInputProps
  } = useDropzone({
    onDrop,
    disabled : isUploading,
    accept   : 'text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })

  const showUploadedFile = file.size === 0
    ?  'Drag and drop a CSV file here, or click to select files to upload'
    : file.name

  return (
    <Card>
      <CardHeader>
        <h3> { label }</h3>
      </CardHeader>
      <CardBody>
        <div { ...getRootProps({ style }) }>
          <input { ...getInputProps() } />
          <p className='font-weight-bold'>
            { showUploadedFile }
          </p>
        </div>
        <LoaderButton
          className='float-right'
          color='primary'
          onClick={ () => onFileUpload(file) }
          isLoading={ isUploading }
          disabled={ file.size === 0 }
          text = 'Upload'
        />
      </CardBody>
      <CardFooter>
        <h3 style={{ color: 'red' }}> { errorMsg } </h3>
      </CardFooter>
    </Card>
  )
}

CsvUploadCard.propTypes = propTypes

export default CsvUploadCard
